
  <div mat-dialog-content><div style="float: right !important;">
    <a
      href="javascript:void(0)"
      (click)="closeModal()"
      style="color: #8f8f8f">
      <mat-icon
        style="size: 18px;"
        matTooltip="Close form"
        matTooltipPosition="below">
        close
      </mat-icon>
    </a>
  </div>
  <pdf-viewer 
      [src]="GetUrl()"
      [render-text]="true"
      [autoresize]="true"
      style="width: 400px; height: 500px"></pdf-viewer>

  </div>
  